import React from 'react';

export default function Modal({ open, onClose, children, width = 420 }) {
  if (!open) return null;
  return (
    <div
      className="modal-backdrop"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.68)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.25s"
      }}
      onClick={onClose}
    >
      <div
        className="modal-content"
        style={{
          background: "#191919",
          borderRadius: 16,
          padding: 32,
          minWidth: width,
          maxWidth: "94vw",
          boxShadow: "0 8px 32px #000c",
          color: "#fafafa",
          position: "relative"
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "none",
            border: "none",
            color: "#fafafa",
            fontSize: 22,
            cursor: "pointer"
          }}
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}
